import * as React from 'react';
import * as styles from './Info.css';
import { UIHeading4, ArticleParagraph3 } from '@cian/ui-kit/typography';
import { Image } from '@cian/ui-kit/image';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Info = function Info(_ref) {
  var type = _ref.type,
    name = _ref.name,
    logoUrl = _ref.logoUrl;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['info'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['logo'],
      children: /*#__PURE__*/_jsx(Image, {
        borderRadius: 0,
        objectFit: 'contain',
        src: logoUrl
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['data'],
      children: [/*#__PURE__*/_jsx(ArticleParagraph3, {
        color: 'gray60_100',
        children: type
      }), /*#__PURE__*/_jsx(UIHeading4, {
        children: name
      })]
    })]
  });
};